<template>
  <div class="table-of-content">
    <p class="h6">
      Table of Content
    </p>
    <hr>
    <ul>
      <li
        v-for="(heading, i) in headings[$store.state.calculators.calculator]"
        :key="i"
        :data-section="`heading${i + 1}`"
        :class="{ active: activeSection === `heading${i + 1}` }"
        @click="scrollToSection"
      >
        <span>{{ heading }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headings: {
        confidenceInterval:
        [
          'Confidence Interval Calculator',
          'What Is a Confidence Interval?',
          'Which Confidence Level Should You Use?',
          'Calculating the Confidence Interval (Formula)',
          'How to Calculate a Confidence Interval with Precision',
        ],
        meanMedianMode: [
          'What Are Mean, Median, and Mode?',
          'What Is the Mean?',
          'What Is the Median?',
          'What Is the Mode?',
          'Comparison of Mean, Median, and Mode',
        ],
        skewness: [
          'What Is Skewness?',
          'How to Handle Skew Data',
          'How to Interpret the Coefficient of Skewness',
          'What is the Difference Between Skewness and Kurtosis?',
        ],
        kurtosis: [
          'What Is Kurtosis?',
          'What Is Excess Kurtosis?',
          'Types of Kurtosis',
          'How to Interpret the Kurtosis Coefficient',
          'What Is the Difference Between Skewness and Kurtosis?',
        ],
        standardDeviation: [
          'What Is Standard Deviation?',
          'What Does Standard Deviation Mean?',
          'Why Is Standard Deviation Important?',
          'How to Calculate the Standard Deviation',
          'Standard Deviation vs Variance',
        ],
        variance: [
          'What Is Variance?',
          'What Is the Importance of Variance in Statistics?',
          'How to Calculate Variance',
          'What Are the Advantages and Disadvantages of Variance?',
          'What Are the Differences Between Variance and Standard Deviation?',
        ],
        coefficientOfVariation: [
          'What Is the Coefficient of Variation (CV)?',
          'What Does Coefficient of Variation Mean?',
          'How to Calculate the Coefficient of Variation',
          'How to Interpret the Coefficient of Variation',
          'Applications of Coefficient Variation',
          'What Are the Advantages and Disadvantages of the Coefficient of Variation?',
          'Coefficient of Variation vs Standard Deviation',
        ],
        linearRegression: [

        ],
      },
      activeSection: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    async scrollToSection(e) {
      let yOffset;
      let buffer = 90;
      if (this.$store.state.layout === 'desktop') {
        if (document.querySelector('.banner-holder')) {
          buffer += document.querySelector('.banner-holder').clientHeight;
        }
        yOffset = -buffer;
      } else {
        buffer = this.$config.project === 'lms' ? 68 : 72;
        if (document.querySelector('.banner-holder')) {
          buffer += document.querySelector('.banner-holder').clientHeight;
        }
        yOffset = -buffer;
      }

      const section = `${e?.target?.getAttribute('data-section') || e?.target?.closest('li')?.getAttribute('data-section')}`;
      const element = document.querySelector(`#${section}`);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      setTimeout(() => {
        this.clickedSection = section;
        window.scrollTo({ top: y, behavior: 'smooth' });

        setTimeout(() => {
          this.clickedSection = null;
        }, 500);
      }, 200);
    },
    handleScroll() {
      let buffer = 92;
      if (document.querySelector('.banner-holder')) {
        buffer += document.querySelector('.banner-holder').clientHeight;
      }
      const sections = document.querySelectorAll('.article-section');
      const current = Array.from(sections).filter((s) => s.getBoundingClientRect().top - buffer <= 0);
      const element = current[current.length - 1];

      if (element) {
        this.activeSection = element.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-of-content {
  height: fit-content;
  position: sticky;
  top: 110px;

  .h6 {
    margin: 0 0 var(--spacing-36)  var(--spacing-16);
  }

  ul {
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      list-style: none;
      font-size: 14px;

      span {
        padding: var(--spacing-12) 0 var(--spacing-12) var(--spacing-16);
      }

      &.active,
      &:hover {
        background: var(--main-light-shade-2);
        border-radius: 5px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }

  hr {
    margin: 0;
    border: 1px solid var(--main-light-shade-3);
    margin-bottom: var(--spacing-24);
  }
}

@include bp($bp-mobile) {
  .table-of-content {
    height: unset;
    margin-bottom: var(--spacing-60);

    .h6 {
      margin: var(--spacing-12) 0 var(--spacing-28) var(--spacing-16);
    }

    hr {
      margin-bottom: var(--spacing-16);
    }
  }
}
</style>
